import { Instance } from 'mobx-state-tree'
import { DailyInspirationAcfModelBase } from './DailyInspirationAcfModel.base'

/* The TypeScript type of an instance of DailyInspirationAcfModel */
export interface DailyInspirationAcfModelType extends Instance<typeof DailyInspirationAcfModel.Type> {}

/* A graphql query fragment builders for DailyInspirationAcfModel */
export {
  selectFromDailyInspirationAcf,
  dailyInspirationAcfModelPrimitives,
  DailyInspirationAcfModelSelector
} from './DailyInspirationAcfModel.base'

/**
 * DailyInspirationAcfModel
 */
export const DailyInspirationAcfModel = DailyInspirationAcfModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
